const MIME_OOXML = "application/vnd.openxmlformats-officedocument";
const MIME_ODF = "application/vnd.oasis.opendocument";

const FILE_TYPES = {
  pdf: { mimes: ["application/pdf"], ext: ".pdf" },
  doc: { mimes: ["application/msword"], ext: ".doc" },
  docx: { mimes: [`${MIME_OOXML}.wordprocessingml.document`], ext: ".docx" },
  xls: { mimes: ["application/vnd.ms-excel"], ext: ".xls" },
  xlsx: { mimes: [`${MIME_OOXML}.spreadsheetml.sheet`], ext: ".xlsx" },
  ppt: { mimes: ["application/vnd.ms-powerpoint"], ext: ".ppt" },
  pptx: {
    mimes: [`${MIME_OOXML}.presentationml.presentation`],
    ext: ".pptx",
  },
  txt: { mimes: ["text/plain"], ext: ".txt" },
  odt: { mimes: [`${MIME_ODF}.text`], ext: ".odt" },
  csv: { mimes: ["text/csv", "application/csv"], ext: ".csv" },
  jpg: { mimes: ["image/jpeg"], ext: ".jpg" },
  jpeg: { mimes: ["image/jpeg"], ext: ".jpeg" },
  png: { mimes: ["image/png"], ext: ".png" },
};

const DEFAULT_MAX_FILE_SIZE = 1024 * 1024;
const BLOCKED_EXTENSIONS = /\.(exe|com|msi)$/i;
const UNSAFE_FILENAME = /[^\w\s\-().]/;

const formatSize = (bytes) => {
  const mb = bytes / (1024 * 1024);
  if (mb >= 1) return `${Number.isInteger(mb) ? mb : mb.toFixed(1)} MB`;
  return `${Math.round(bytes / 1024)} KB`;
};

export function resolveFileTypes(types) {
  if (!types) return { mimes: null, accept: "all", display: null };
  return {
    mimes: types.flatMap((key) => FILE_TYPES[key]?.mimes ?? []),
    accept: types.map((key) => FILE_TYPES[key]?.ext).join(","),
    display: types.map((key) => FILE_TYPES[key]?.ext ?? `.${key}`).join(", "),
  };
}

export function validateFile(
  file,
  allowedTypes,
  maxSize = DEFAULT_MAX_FILE_SIZE,
) {
  if (UNSAFE_FILENAME.test(file.name))
    return "File name contains unsupported characters. Please rename the file and try again.";

  if (BLOCKED_EXTENSIONS.test(file.name))
    return "Uploading .exe, .com, and .msi files is not allowed.";

  const { mimes, display } = resolveFileTypes(allowedTypes);

  if (mimes && !mimes.includes(file.type))
    return `Only the following file types are allowed: ${display}.`;

  if (file.size > maxSize)
    return `File size must not exceed ${formatSize(maxSize)}.`;

  return null;
}
